module.exports = __webpack_public_path__ + "static/image2-f4a988d30e2efcd0893cb77e702d8d7e.jpg";